// eslint-disable-next-line import/prefer-default-export
export enum StripesProductsNames {
  regularCandidate= 'cv candidat',
  rareGemCandidate= 'cv candidat perle rare',
  baseAffiliateKit= 'Kit de base Affilié',
  premiumHeadhunter= 'Abonnement chasseur de tete premium',
  additionalPoster = 'Affiche supplémentaire - Kit affilié',
  additionalSticker = 'stickers supplémentaires - kit affilié'
}
